import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({ baseURL: BACKEND_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token && config.url?.includes('/admin/')) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ─── Public API ───
export const publicApi = {
  getPlayers: (position) => {
    const params = position ? { position } : {};
    return api.get('/api/public/players', { params });
  },
  getPlayer: (id) => api.get(`/api/public/players/${id}`),
  getTeams: () => api.get('/api/public/teams'),
  getGames: (status, season) => {
    const params = {};
    if (status) params.status = status;
    if (season) params.season = season;
    return api.get('/api/public/games', { params });
  },
  getUpcomingGames: (limit = 5) => api.get('/api/public/games/upcoming', { params: { limit } }),
  getRecentGames: (limit = 5) => api.get('/api/public/games/recent', { params: { limit } }),
  getFeaturedGame: () => api.get('/api/public/games/featured'),
  getSettings: () => api.get('/api/public/settings'),
  getSponsors: () => api.get('/api/public/sponsors'),
  getGallery: () => api.get('/api/public/gallery'),
};

// ─── Admin API ───
export const adminApi = {
  login: (password) => api.post('/api/admin/login', { password }),
  getStats: () => api.get('/api/admin/stats'),
  getSeasons: () => api.get('/api/admin/seasons'),
  getOpponentStats: (season) => {
    const params = season ? { season } : {};
    return api.get('/api/admin/stats/opponents', { params });
  },
  // Players
  createPlayer: (formData) => api.post('/api/admin/players', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  updatePlayer: (id, formData) => api.put(`/api/admin/players/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deletePlayer: (id) => api.delete(`/api/admin/players/${id}`),
  // Games
  createGame: (data) => api.post('/api/admin/games', data),
  updateGame: (id, data) => api.put(`/api/admin/games/${id}`, data),
  deleteGame: (id) => api.delete(`/api/admin/games/${id}`),
  // Teams
  createTeam: (formData) => api.post('/api/admin/teams', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  updateTeam: (id, formData) => api.put(`/api/admin/teams/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deleteTeam: (id) => api.delete(`/api/admin/teams/${id}`),
  // Club Logo + Hero BG
  uploadClubLogo: (formData) => api.post('/api/admin/settings/logo', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  uploadHeroBg: (formData) => api.post('/api/admin/settings/hero-bg', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  // Sponsors
  createSponsor: (formData) => api.post('/api/admin/sponsors', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  updateSponsor: (id, formData) => api.put(`/api/admin/sponsors/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deleteSponsor: (id) => api.delete(`/api/admin/sponsors/${id}`),
  // Gallery
  addGalleryImage: (formData) => api.post('/api/admin/gallery', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  deleteGalleryImage: (id) => api.delete(`/api/admin/gallery/${id}`),
};

export const getImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${BACKEND_URL}${path}`;
};

export default api;
